import { defineMessage } from 'services/localization';

export const messages = {
    bubbleText: defineMessage('creation_pulling_of_pluraltemplatename'),
    title: defineMessage('there_are_several_metho_nd_choose_as_applicable'),
    createInApprovalMax: defineMessage('create_in_approvalmax'),
    description: defineMessage('add_users_authorised_to_approval_in_approvalmax_2'),
    descriptionEmpty: defineMessage('add_at_least_one_user_a_approval_in_approvalmax_1'),
    externalSubmitterTitle: defineMessage('pluraltemplatename_in_t_ically_pulled_from_xero'),
    externalSubmitterDescriptionNonEmpty: defineMessage('pluraltemplatename_will_rejections_and_comments_1'),
    externalSubmitterDescriptionEmpty: defineMessage('enter_the_user_who_will_anycom_can_also_be_used_1'),
    emailExternalSubmitterTitle: defineMessage('approvalmax_will_create_the_email_address_below'),
    emailExternaSubmitterDescriptionNonEmpty: defineMessage('pluraltemplatename_will_ubmit_them_for_approval'),
    emailExternalSubmitterDescriptionEmpty: defineMessage('enter_the_user_who_will_anycom_can_also_be_used_1'),
};
